/* eslint-disable tsdoc/syntax */
/* tslint:disable */
/* eslint-disable */

export type TransactionsParametersRecord = {
  page?: number;
  size?: number;
  direction?: TransactionsParametersRecord.direction;
  orderBy?: TransactionsParametersRecord.orderBy;
  transactionDateStart?: string;
  transactionDateEnd?: string;
  paymentMethods?: Array<
    | "USSD"
    | "QR_CODE"
    | "IN_BANK_TRANSFER"
    | "INWARDS_TRANSFER"
    | "PAY_WITH_TRANSFER"
    | "PAYMENT_LINK_PAY_WITH_TRANSFER"
    | "MOMO"
    | "OUT_BANK_TRANSFER"
    | "REFUND"
    | "PAYMENT_LINK_CARD"
    | "PAYMENT_LINK_USSD"
    | "PAYMENT_LINK_QR_CODE"
    | "PAYMENT_LINK_BANK_TRANSFER"
    | "POS"
    | "POS_ORDER"
    | "STAMP_DUTY"
    | "TRANSACTION_CHARGE"
  >;
  minimumAmount?: number;
  maximumAmount?: number;
  searchInput?: string;
};

export namespace TransactionsParametersRecord {
  export enum direction {
    ASC = "ASC",
    DESC = "DESC",
  }

  export enum orderBy {
    TRANSACTION_DATE = "TRANSACTION_DATE",
    PAYMENT_METHOD = "PAYMENT_METHOD",
    TOTAL_AMOUNT = "TOTAL_AMOUNT",
    STATUS = "STATUS",
    WALLET_ID = "WALLET_ID",
    CORE_TRANSACTION_ID = "CORE_TRANSACTION_ID",
    USER_ID = "USER_ID",
  }
}

export type TransactionsParametersExportRecord = {
  mediaType?: TransactionsParametersExportRecord.mediaType;
  page?: number;
  size?: number;
  direction?: TransactionsParametersExportRecord.direction;
  orderBy?: TransactionsParametersExportRecord.orderBy;
  transactionDateStart?: string;
  transactionDateEnd?: string;
  paymentMethods?: Array<
    | "USSD"
    | "QR_CODE"
    | "IN_BANK_TRANSFER"
    | "INWARDS_TRANSFER"
    | "PAY_WITH_TRANSFER"
    | "PAYMENT_LINK_PAY_WITH_TRANSFER"
    | "MOMO"
    | "OUT_BANK_TRANSFER"
    | "REFUND"
    | "PAYMENT_LINK_CARD"
    | "PAYMENT_LINK_USSD"
    | "PAYMENT_LINK_QR_CODE"
    | "PAYMENT_LINK_BANK_TRANSFER"
    | "POS"
    | "POS_ORDER"
    | "STAMP_DUTY"
    | "TRANSACTION_CHARGE"
  >;
  minimumAmount?: number;
  maximumAmount?: number;
  transactionId?: string;
};

export namespace TransactionsParametersExportRecord {
  export enum direction {
    ASC = "ASC",
    DESC = "DESC",
  }

  export enum mediaType {
    PDF = "PDF",
    CSV = "CSV",
    XLSX = "XLSX",
  }

  export enum orderBy {
    TRANSACTION_DATE = "TRANSACTION_DATE",
    PAYMENT_METHOD = "PAYMENT_METHOD",
    TOTAL_AMOUNT = "TOTAL_AMOUNT",
    STATUS = "STATUS",
    WALLET_ID = "WALLET_ID",
    CORE_TRANSACTION_ID = "CORE_TRANSACTION_ID",
    USER_ID = "USER_ID",
  }
}

export type StatementExportRequestDTO = {
  dateEnd: string;
  dateStart: string;
};

export type OperationsParametersRecord = {
  page?: number;
  size?: number;
  direction?: OperationsParametersRecord.direction;
  orderBy?: OperationsParametersRecord.orderBy;
  operationDateStart?: string;
  operationDateEnd?: string;
  paymentMethods?: Array<
    | "CASH"
    | "POS"
    | "POS_ORDER"
    | "USSD"
    | "QR_CODE"
    | "IN_BANK_TRANSFER"
    | "INWARDS_TRANSFER"
    | "PAY_WITH_TRANSFER"
    | "PAYMENT_LINK_PAY_WITH_TRANSFER"
    | "MOMO"
    | "PAYMENT_LINK"
    | "OUT_BANK_TRANSFER"
    | "REFUND"
    | "CARD"
  >;
  minimumAmount?: number;
  maximumAmount?: number;
  status?: Array<"SUCCESS" | "EXPIRED" | "PENDING" | "DECLINED" | "FAILED">;
};

export namespace OperationsParametersRecord {
  export enum direction {
    ASC = "ASC",
    DESC = "DESC",
  }

  export enum orderBy {
    OPERATION_DATE = "OPERATION_DATE",
    WALLET_ID = "WALLET_ID",
    PAYMENT_METHOD = "PAYMENT_METHOD",
    OPERATION_ID = "OPERATION_ID",
    TOTAL_AMOUNT = "TOTAL_AMOUNT",
    STATUS = "STATUS",
    USER_ID = "USER_ID",
  }
}

export type OperationsParametersExportRecord = {
  mediaType?: OperationsParametersExportRecord.mediaType;
  page?: number;
  size?: number;
  direction?: OperationsParametersExportRecord.direction;
  orderBy?: OperationsParametersExportRecord.orderBy;
  operationDateEnd?: string;
  operationDateStart?: string;
  paymentMethods?: Array<
    | "CASH"
    | "POS"
    | "POS_ORDER"
    | "USSD"
    | "QR_CODE"
    | "IN_BANK_TRANSFER"
    | "INWARDS_TRANSFER"
    | "PAY_WITH_TRANSFER"
    | "PAYMENT_LINK_PAY_WITH_TRANSFER"
    | "MOMO"
    | "PAYMENT_LINK"
    | "OUT_BANK_TRANSFER"
    | "REFUND"
    | "CARD"
  >;
  minimumAmount?: number;
  maximumAmount?: number;
  status?: Array<"SUCCESS" | "EXPIRED" | "PENDING" | "DECLINED" | "FAILED">;
};

export namespace OperationsParametersExportRecord {
  export enum direction {
    ASC = "ASC",
    DESC = "DESC",
  }

  export enum mediaType {
    PDF = "PDF",
    CSV = "CSV",
  }

  export enum orderBy {
    OPERATION_DATE = "OPERATION_DATE",
    WALLET_ID = "WALLET_ID",
    PAYMENT_METHOD = "PAYMENT_METHOD",
    OPERATION_ID = "OPERATION_ID",
    TOTAL_AMOUNT = "TOTAL_AMOUNT",
    STATUS = "STATUS",
    USER_ID = "USER_ID",
  }
}